import React, { useEffect, useState } from "react";
import TableHeading from "../../Components/common/table/Tableheading";
import { showData } from "../../Utils/APIs/commonShowAPI";
import axios from "axios";
const PaymentListForAccount = () => {
  const [paymentRequestList, setPaymentRequestList] = useState([]);
  const [reloadPaymentList, setReloadPaymentList] = useState(false);
  const fetch = async () => {
    try {
      await showData(
        "installer/getPaymentRequestsByInstallerForAccount",
        setPaymentRequestList,
      );
    } catch (error) {
      alert("something is wrong please try again to fetch payment list");
    }
  };
  useEffect(() => {
    fetch();
  }, [reloadPaymentList]);
  // update 2.0
  const [openInstaller, setOpenInstaller] = useState(null);
  const [loading, setLoading] = useState(false);
  const toggleInstaller = (id) => {
    setOpenInstaller(openInstaller === id ? null : id);
  };
  const handlePayment = async (installerContact, status) => {
    setLoading(true);
    const payment = paymentRequestList.find(
      (p) => p.installerContact === installerContact,
    );
    const res = payment?.requests?.map((item) => item._id) || [];
    const response = await axios.put(`${process.env.REACT_APP_API_URL}/installer/updateManyInstallerData`,
      {
        _id:res,
        status
      },
    );
    if(response?.data?.success){
      await fetch();
      alert(response?.data?.message);
    }
    setLoading(false);
  };
  return (
    <div className="w-full h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-8 overflow-scroll pb-32">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-slate-900 mb-2">
          Payment Management
        </h1>
        <p className="text-slate-600">Manage installer payment requests</p>
      </div>

      {/* Payment List */}
      <div className="space-y-4">
        {paymentRequestList.map((installer) => (
          <div
            key={installer.installerId}
            className="bg-white rounded-lg shadow-sm border border-slate-200 hover:shadow-md transition-shadow"
          >
            {/* Summary Section */}
            <div
              className="p-6 cursor-pointer hover:bg-slate-50 transition-colors"
              onClick={() => toggleInstaller(installer?.installerId)}
            >
              <div className="flex justify-between items-start gap-6">
                {/* Left: Installer Info */}
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-slate-900 mb-3">
                    {installer?.installerName}
                  </h3>
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-slate-500 text-xs uppercase tracking-wide">
                        Contact
                      </p>
                      <p className="text-slate-900 font-medium">
                        📞 {installer?.installerContact}
                      </p>
                    </div>
                    <div>
                      <p className="text-slate-500 text-xs uppercase tracking-wide">
                        Bank Details
                      </p>
                      <p className="text-slate-900 font-medium">
                        {installer?.bankName}
                      </p>
                      <p className="text-slate-600 text-xs">
                        A/C:{" "}
                        <span className="font-medium text-slate-900">
                          {installer?.accountNumber}
                        </span>
                      </p>
                    </div>
                    <div>
                      <p className="text-slate-500 text-xs uppercase tracking-wide">
                        IFSC Code
                      </p>
                      <p className="text-slate-900 font-medium">
                        {installer?.IFSC_code}
                      </p>
                    </div>
                    <div>
                      <p className="text-slate-500 text-xs uppercase tracking-wide">
                        Account Holder
                      </p>
                      <p className="text-slate-900 font-medium">
                        {installer?.accountHolderName}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Middle: Amount */}
                <div className="text-center">
                  <p className="text-slate-500 text-xs uppercase tracking-wide mb-2">
                    Total Amount
                  </p>
                  <p className="text-3xl font-bold text-green-600">
                    ₹{installer?.totalAmount.toLocaleString()}
                  </p>
                  <p className="text-sm text-slate-600 mt-2">
                    {installer?.totalRequests} Requests
                  </p>
                </div>

                {/* Right: Actions */}
                <div className="flex gap-2 flex-col">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePayment(installer?.installerContact, "Approved");
                    }}
                    disabled={loading}
                    className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
                  >
                    Approve
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePayment(installer?.installerContact, "Reject");
                    }}
                    disabled={loading}
                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium transition-colors disabled:opacity-50"
                  >
                    Reject
                  </button>
                </div>
              </div>
            </div>

            {/* Details Table */}
            {openInstaller === installer.installerId && (
              <div className="border-t border-slate-200 p-6 h-full overflow-scroll">
                <h4 className="text-sm font-semibold text-slate-900 mb-4">
                  Payment Requests
                </h4>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="border-b border-slate-200 bg-slate-50">
                        <th className="px-4 py-3 text-left text-slate-700 font-semibold">
                          #
                        </th>
                        <th className="px-4 py-3 text-left text-slate-700 font-semibold">
                          Saral ID
                        </th>
                        <th className="px-4 py-3 text-left text-slate-700 font-semibold">
                          Amount
                        </th>
                        <th className="px-4 py-3 text-left text-slate-700 font-semibold">
                          Status
                        </th>
                        <th className="px-4 py-3 text-left text-slate-700 font-semibold">
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {installer?.requests.map((req, index) => (
                        <tr
                          key={req._id}
                          className="border-b border-slate-100 hover:bg-slate-50"
                        >
                          <td className="px-4 py-3 text-slate-900">
                            {index + 1}
                          </td>
                          <td className="px-4 py-3 text-slate-900 font-medium">
                            {req?.saralId}
                          </td>
                          <td className="px-4 py-3 text-green-600 font-semibold">
                            ₹{req?.amount.toLocaleString()}
                          </td>
                          <td className="px-4 py-3">
                            <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                              {req?.status}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-slate-600">
                            {new Date(req?.createdAt).toLocaleDateString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentListForAccount;
